import { Box, Tooltip, IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useSondertagContext } from "../context/sondertagContext";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { useState } from "react";

import useSondertagStats from "../hooks/useSondertagStats";
import SondertagStatsInfoDialog from "./SondertagStatsInfoDialog";

function getTargetParts(value = 0) {
  const floor = Math.floor(value);
  const ceil = Math.ceil(value);
  const decimal = value - floor;

  return {
    floor,
    ceil,
    isExact: floor === ceil,
    fadeFloor: decimal > 0.2, // ✅ your rule
  };
}

export default function SondertagStatsDisplay() {
  const theme = useTheme();

  const { currentUser, isMobile } = useAppContext();
  const { statsAngebote, statsMeta } = useSondertagContext();
  const { mySlotsCount, myTargetSlots } = useSondertagStats(
    statsAngebote,
    currentUser,
  );

  const [infoOpen, setInfoOpen] = useState(false);

  const { floor, ceil, isExact, fadeFloor } = getTargetParts(myTargetSlots);

  const ratio = myTargetSlots > 0 ? mySlotsCount / myTargetSlots : 0;

  const color =
    ratio < 0.9
      ? theme.palette.error.main
      : ratio > 1.1
        ? theme.palette.success.main
        : theme.palette.success.main;

  return (
    <>
      <Tooltip title={`Ziel: ${myTargetSlots.toFixed(1)} Angebote`}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            px: 1.5,
            py: 0.5,
            borderRadius: 2,
            backgroundColor: theme.palette.action.hover,
            cursor: "help",
          }}
        >
          <Box sx={{ opacity: 0.7 }}>
            {isMobile ? "Ziel:" : "Dein Jahresziel: "}{" "}
          </Box>

          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.4,
              // fontWeight: 600,
              color,
              lineHeight: 0.4, // ✅ removes baseline weirdness
            }}
          >
            <Box component="span">
              {mySlotsCount} {isMobile ? "/" : "von "}
              {isExact ? (
                floor
              ) : (
                <>
                  <span style={{ opacity: fadeFloor ? 0.6 : 1 }}>{floor}</span>
                  <span>–</span>
                  <span style={{ opacity: !fadeFloor ? 0.6 : 1 }}>{ceil}</span>
                </>
              )}
            </Box>

            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setInfoOpen(true);
              }}
              sx={{
                p: 0.3, // ✅ smaller padding = better alignment
                ml: 0.2,
                mt: "1px", // ✅ tiny visual correction (optional)
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: "1rem" }} />{" "}
              {/* ✅ normalize icon */}
            </IconButton>
          </Box>
        </Box>
      </Tooltip>

      <SondertagStatsInfoDialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        targetValue={myTargetSlots}
        totalWork={statsMeta.totalWork}
        totalSlots={statsMeta.totalSlots}
        noTeacherSlots={statsMeta.noTeacherSlots}
        totalWorkload={statsMeta.totalWorkload}
      />
    </>
  );
}
